import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {sync} from 'vuex-router-sync'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'

import Input from '@/admin/components/Input'
Vue.component('input-vue', Input);

sync(store, router);
Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;

Vue.use(VueClipboard);
Vue.use(VueCookies);

require('@/scss/app.scss');

//router.beforeEach((to, from, next) => { if (to.matched.some(record => record.meta.requiresAuth)) ? next() : next()});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
